/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React, { useEffect } from "react";
import { Link, WithPreview } from "@quintype/components";
import { object, shape, string } from "prop-types";
import { pageview } from "../../../utils/gtm";
import {
  AuthorElement,
  HeroImageWithCaption,
  RenderArticleContent,
  RenderTag,
  StorySummary,
  RenderAuthorBio,
  RenderWhatsAppChannel,
} from "../../templates/StoryElements";
import SocialShare from "../../common/SocialShare";
import TwoComponentCol from "../../templates/TwoComponentCol";
import MultiColumn from "../../templates/MultiColumn";
import MagazineSideCol from "../../common/MagazineSideCol";
import AppealBox from "../../common/Appealbox";
import Ads from "../../ads/Ads";
import { adUnits } from "../../ads/ad-units";
import SubscribeBox from "../../templates/SubscribeBox";
import Comments from "./Comments";
import { v4 as uuidv4 } from "uuid";
import SettingPaywall from "./SettingPaywall";
import BookmarkIcon from "../../common/BookmarkIcon";

const TOP_MULTI_COLUMN_SECTIONS = ["Defence", "World", "Culture", "Politics", "Economy", "Infrastructure"];

// Prefer Button Component
const PreferButton = () => {
  return (
    <Link
      target="_blank"
      href="https://www.google.com/preferences/source?q=swarajyamag.com"
      className="bg-black text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-gray-800 transition-colors duration-200 text-sm font-medium"
    >
      <span>Prefer</span>
      <div className="flex items-center">
        <svg width="20" height="20" viewBox="0 0 24 24" className="flex-shrink-0">
          <path
            fill="#4285F4"
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          />
          <path
            fill="#34A853"
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          />
          <path
            fill="#FBBC05"
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          />
          <path
            fill="#EA4335"
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          />
        </svg>
      </div>
    </Link>
  );
};
export function StoryPage(props) {
  const story = props.data.story;
  const homeData = props.data.homeData || {};
  const data = homeData?.collection?.items;
  const sectionStories = homeData?.sectionStories;
  const storyCard = story?.cards?.[0]?.["story-elements"]?.[0];
  useEffect(() => {
    pageview();

    if (document.cookie.indexOf("readerID") === -1) {
      document.cookie = `readerID=${uuidv4()};path=/;max-age=31536000`;
    }
  }, []);

  return (
    <div className="container">
      <section className=" mx-auto mb-10 flex max-w-[1022px] justify-center gap-6 mobile:mb-1 tablet:flex-col tablet:items-center">
        <div className="max-w-[610px] tablet:w-[90%] tablet:mobile:w-[100%]">
          <div className="mb-4 flex flex-col gap-6">
            <div className="flex flex-col gap-[12px]">
              <Link href={`/section/${story?.sections?.[0]?.slug || ""}`}>
                <p className="text-[20px] font-bold uppercase text-primary mobile:text-xs">
                  {story?.sections?.[0]?.name}
                </p>
              </Link>
              <h1 className=" text-4xl font-bold leading-[130%] tracking-[-0px] mobile:text-[24px] mobile:font-[600] mobile:leading-[140%]">
                {story?.headline}
              </h1>
              <div className=" flex justify-between">
                <AuthorElement story={story} />
                <div className="flex flex-col items-end gap-2 mobile:gap-1">
                  <div className="flex items-center gap-3">
                    <BookmarkIcon story={story} />
                    <SocialShare url={story.url} headline={story?.headline} story={story} />
                    <div className="mobile:hidden">
                      <PreferButton />
                    </div>
                  </div>
                  <div className="hidden mobile:block mobile:mt-[5px]">
                    <PreferButton />
                  </div>
                </div>
              </div>
            </div>
            <HeroImageWithCaption story={story} />
          </div>
          {storyCard?.type === "text" && storyCard?.subtype === "summary" ? (
            <StorySummary summary={storyCard.text} />
          ) : (
            <></>
          )}
          <SettingPaywall accessLevel={story.access} id={story.id} cards={story.cards} storyDetail={story}>
            <RenderArticleContent story={story} />
          </SettingPaywall>
          {story?.authors[0]?.bio && <RenderAuthorBio story={story} />}
          <RenderTag story={story} />
          <RenderWhatsAppChannel />

          <Comments
            url={story.url}
            // account_id={props.config?.["publisher-attributes"]?.metypeConfig?.metypeAccountId}
            account_id={4}
          />
          <br />

          <AppealBox />
        </div>

        <div className="flex flex-col max-w-[300px] tablet:w-[300px] tablet:mobile:w-[100%]">
          <div className="mt-5">
            <SubscribeBox />
          </div>

          <MagazineSideCol />

          <Ads adunit={adUnits["desktop-ap-rightatf-300x250"]} />
          {/* <ResponsiveRendering> */}
          <Ads adunit={adUnits["desktop-ap-right-300x600"]} />
          <></>
          {/* </ResponsiveRendering> */}
        </div>
      </section>
      <div className="  mx-auto mb-10 flex  justify-center gap-6 mobile:mb-1 tablet:flex-col tablet:items-center">
        <MultiColumn sections={TOP_MULTI_COLUMN_SECTIONS} sectionStories={sectionStories} />
      </div>
      <div className="  mx-auto mb-10 flex  justify-center gap-6 mobile:mb-1 tablet:flex-col tablet:items-center">
        <TwoComponentCol data={data} />
      </div>
    </div>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object,
    homeData: object,
    config: object,
  }),
  currentPath: string,
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story),
  })
);
